import { find } from 'lodash';
import AbstractAuthenticatedService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/abstract-authenticated-service';
import GetSitesTask from '@/model/task/ecommerce/get-sites-task';
import Site from '@/model/entity/ecommerce/site';
import SiteSearchResultsVo from '@/model/vo/ecommerce/site-search-results-vo';

export default class SiteService extends AbstractAuthenticatedService
{
    private cachedAllSites: Site[]|null = null;

    /**
     * Returns all the sites
     *
     * @returns
     */

    public async loadSites(): Promise<Site[]>
    {
        if (this.cachedAllSites)
        {
            return this.cachedAllSites;
        }

        const task = new GetSitesTask();
        task.token = this.token;
        task.searchConditions = {
            itemsPerPage: 1000,
            order: [
                {
                    key: 'name',
                    descending: false,
                },
            ],
        };

        const results = await (this.runTask(task) as Promise<SiteSearchResultsVo>);

        this.cachedAllSites = results.results;

        return this.cachedAllSites;
    }

    /**
     * Returns whether a client is an ecommerce client
     *
     * @param clientId
     * @returns
     */

    public async clientIsEcommerce(clientId: number): Promise<boolean>
    {
        const sites = await this.loadSites();

        return !!(find(sites, { clientId }));
    }
}